import ControlArea from "components/Layout/ControlArea";
import React, { useEffect } from "react";
import Table from "./Table";
import shareIcon from "assets/svgs/clients.svg";
import { useDispatch } from "react-redux";
import { getClients } from "store/clients/actions";

const Index = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getClients());
  }, [dispatch]);

  return (
    <>
      <div className="users-wrap">
        <ControlArea
          btnTxt="اضافة عميل جديد"
          cardTxt="العملاء"
          icon={shareIcon}
          url="/clients/add"
        />
        <Table />
      </div>
    </>
  );
};

export default Index;
